var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13516 0H15.8685V1.53333H20.4685V20.7C20.4685 21.31 20.2262 21.895 19.7948 22.3263C19.3635 22.7577 18.7785 23 18.1685 23H2.83516C2.22516 23 1.64014 22.7577 1.20881 22.3263C0.777477 21.895 0.535156 21.31 0.535156 20.7V1.53333H5.13516V0ZM6.66849 1.53333H14.3352V3.83333C14.3352 4.03667 14.2544 4.23167 14.1106 4.37545C13.9668 4.51923 13.7718 4.6 13.5685 4.6H7.43516C7.23182 4.6 7.03682 4.51923 6.89304 4.37545C6.74926 4.23167 6.66849 4.03667 6.66849 3.83333V1.53333ZM9.77196 17.2224L15.6784 10.4711L14.5253 9.4622L9.69836 14.9791L7.21129 12.4905L6.12569 13.5761L9.77196 17.2224Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCompleted);
export default __webpack_public_path__ + "static/media/TotalCompleted.0668cf21180007262f00be179bea0715.svg";
export { ForwardRef as ReactComponent };